import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {ToastrService} from 'ngx-toastr';
import {filter, map, take} from 'rxjs/operators';
import {combineLatest} from 'rxjs';
import {Router} from "@angular/router";
import {IPage} from "../../../../interfaces";
import {BlockBaseComponent} from "../block-base/block-base.component";
import {SceneMimeTypes} from "../mime-constants";
import {ContainerService, StoreSelectorsService} from "../../../../services";
import {IButtonBar} from "../../../../components/add-remove-bar/button-bar.component";
import {ITableListColumn, ITableListEvent} from "../../../../components/table-list-input/table-list-input.component";
import {actionSceneItemPlaylist, actionSceneJumpLinked} from "../../../../store/actions/user.actions";
import {DialogGetAssetComponent, IDialogGetAsset} from "../../../../components/dialog-get-asset/dialog-get-asset.component";
import {compareIds, getTotalLengthPlaylist, isNullOrUndef, isNullOrUndefOrEmpty, MAX_PLAYLIST_TIME} from "../../../../common";
import {faCrosshairs, faImage, faPlayCircle, IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {ITableIconPipe} from "../../../../pipes/table-list-icon-pipe";
import {Memoizee} from "../../../../decorators/memoizee-decorator";
import {Lib} from "../../../../../libs/Lib";
import * as _ from "lodash";

@Component({
    selector: 'app-block-flicking',
    templateUrl: './block-flicking.component.html',
    styleUrls: ['./block-flicking.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockFlickingComponent extends BlockBaseComponent {

    buttons: IButtonBar[] = [];
    tableColumns: Array<ITableListColumn> = [];

    constructor(
        private translocoService: TranslocoService,
        public override storeSelector: StoreSelectorsService,
        private containerService: ContainerService,
        private toastr: ToastrService,
        public override dialog: MatDialog,
        public cd: ChangeDetectorRef,
        private router: Router
    ) {
        super(storeSelector, dialog);
        this.tableColumns = [{
            inputType: 'text',
            name: 'page',
            maxStringSize: '20'
        }];
        this.buttons = [
            // {
            //     callBack: v => (v),
            //     icon: 'settings_overscan',
            //     name: 'list',
            //     disableByList: false,
            //     disabled: false,
            //     tooltip: this.translocoService.translate('general.expandPlaylist', {}, this.translocoService.getActiveLang())
            // },
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false,
                tooltip: this.translocoService.translate('general.add', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'link',
                name: 'link',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.jumpToItem', {}, this.translocoService.getActiveLang()),
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                disableByList: true,
                confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
                disabled: false,
                tooltip: this.translocoService.translate('general.remove', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_left',
                name: 'previous',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.next', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_right',
                name: 'next',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.previous', {}, this.translocoService.getActiveLang())
            }
        ];
    }

    onPlaylistTimeline() {
        this.containerService.updateEditorMode('playlistMode');
    }

    override componentInit() {
        super.componentInit();
        const playlistIndexes$ = this.storeSelector.listenSelectedScenePlaylist();
        const sceneUpdate$ = this.storeSelector.listenPlayersOfScene(this.sceneId);
        this.cod(
            combineLatest([playlistIndexes$, sceneUpdate$]).pipe(
                map(([indexes, sceneUpdate]) => {
                    return indexes;
                }),
                filter((v) => v !== null)
            ).subscribe((indexes) => {
                super.initApplyStoreToDynamic(true);
                if (!this.dynamicsInitialized) {
                    setTimeout(() => {
                        this.tableListSelection('Page', indexes);
                    }, 333);
                } else {
                    this.tableListSelection('Page', indexes);
                }
                this.cd.markForCheck();
            })
        );
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        // super.initApplyStoreToDynamic(true);
        this.cd.markForCheck();
    }

    updateTransition() {

    }

    private onTableListChangeCallBack(e: ITableListEvent) {
        if (e.currentAction === 'selected') {
            this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: e.selectedIndexes}));

        } else if (e.currentAction === 'previous' || e.currentAction === 'next') {
            // this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: e.selectedIndexes}));

        } else if (e.currentAction === 'link') {
            this.jumpToPlayer(e.selected[0]);

        } else if (e.currentAction === 'rename') {
            const oldPages = this.sceneItem.Data[0].Flicking[0].Page;
            let newPages = e.values;
            if (newPages && _.isArray(newPages)) {
                const len = getTotalLengthPlaylist(newPages);
                if (len > MAX_PLAYLIST_TIME) {
                    this.showToastOverLength();
                    // this.storeSelector.dispatch({type: 'UNDO'});
                    newPages = oldPages;
                }
                this.dispatchSceneItemChanges({
                    sceneId: this.sceneId,
                    sceneItemId: this.sceneItem.$.id,
                    values: [{
                        key: 'Page',
                        value: newPages,
                        storePath: 'Data[0].Flicking[0]'
                    }]
                });
                super.initApplyStoreToDynamic(true);
            }

        } else if (e.currentAction === 'drop' || e.currentAction === 'removed') {
            this.dispatchSceneItemChanges({
                sceneId: this.sceneId,
                sceneItemId: this.sceneItem.$.id,
                values: [{
                    key: 'Page',
                    value: e.values,
                    storePath: 'Data[0].Flicking[0]'
                }]
            });
            if (e.currentAction === 'removed') {
                this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: []}));
            }
        } else if (e.currentAction === 'list') {
            this.onPlaylistTimeline();
        } else if (e.currentAction === 'added') {
            this.openAssociateDialog(true, 'Page');
            this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: []}));
        }
    }

    @Memoizee({})
    onCallBackIcon(v: ITableIconPipe): IconDefinition {
        if (v.index === 0) {
            if (v.params.$.type === "scene") {
                return faCrosshairs;
            } else {
                if (compareIds(v.params.Player[0]?.$.player, '3100')) {
                    return faPlayCircle;
                }
                return faImage;
            }
        }
        return null;
    }

    override submit(formValues) {
        super.submit(formValues);
        // if (this.onFormSubmitAction(formValues)) {
        //     super.submit(formValues);
        // }
    }

    jumpToPlayer(item) {
        const itemType = item?.$?.type;
        if (!item || !itemType) return;

        if (itemType === 'scene') {
            const src = item?.Player[0]?.$?.src;
            if (!src) return;

            this.storeSelector.dispatch(actionSceneJumpLinked({previousLinkedSceneId: this.sceneId}));
            this.containerService.updateEditorMode(null);
            this.router.navigateByUrl(`/editor/scene/${src}`);
        } else {
            this.router.navigateByUrl(`/resources/list?filter=${item.$.page}`);
        }
    }

    /** Unused function */
    private onFormSubmitAction(e): boolean {
        let returnVal = null;
        Object.entries(e).map((items: Array<any>) => {
            const tableName = items[0];
            items.forEach((val: ITableListEvent) => {
                if (isNullOrUndef(val?.currentAction)) return returnVal = true;
                Lib.DevShow(`>>> onFormSubmitAction ${tableName} | ${val.currentAction}| selected ${val.selected.length} | values ${val.values.length}`);
                switch (val.currentAction) {
                    case 'selected': {
                        return returnVal = false;
                    }
                    case 'externallySelected': {
                        return returnVal = true;
                    }
                    case 'list': {
                        this.onPlaylistTimeline();
                        return returnVal = false;
                    }
                    case 'added': {
                        this.openAssociateDialog(true, tableName);
                        this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: []}));
                        return returnVal = true;
                    }
                    case 'removed':
                    case 'rename': {
                        return returnVal = true;
                    }
                    default: {
                        return returnVal = true;
                    }
                }
            });
        });
        return returnVal;
    }

    openAssociateDialog(addingNew, tableName: 'pageGps' | 'Page') {
        const data: IDialogGetAsset = {mode: "SCENE:PLAYER", mimeType: SceneMimeTypes.Player, multiSelect: true};
        const dialogRefVal = this.dialog.open(DialogGetAssetComponent, {
            width: '70%',
            panelClass: 'custom-dlg-container',
            data
        });
        this.cod(
            dialogRefVal.afterClosed()
                .pipe(take(1))
                .subscribe((dialogGetAssets: IDialogGetAsset[]) => {
                    if (!dialogGetAssets || !Array.isArray(dialogGetAssets)) return;

                    this.addTableItem(dialogGetAssets);
                })
        );
    }

    addTableItem(dialogGetAssets: IDialogGetAsset[]) {
        let pager: IPage;
        const pages = this.sceneItem.Data[0].Flicking[0].Page && _.isArray(this.sceneItem.Data[0].Flicking[0].Page) ? _.cloneDeep(this.sceneItem.Data[0].Flicking[0].Page) : [];
        const len = getTotalLengthPlaylist(pages);

        for (const dialogGetAsset of dialogGetAssets) {
            switch (dialogGetAsset.selectedType) {
                case "RESOURCE_SELECTED": {
                    const resource_type = dialogGetAsset.sourceData.resource_type.toLowerCase();
                    const playerId = (["mp4", "mov", "m4v", "3gp"].indexOf(resource_type) > -1) ? "3100" : "3130";
                    pager = {
                        $: {
                            page: `${dialogGetAsset.sourceData.resource_name}`,
                            type: "resource"
                        },
                        Player: [
                            {
                                "$": {
                                    player: playerId,
                                    id: _.uniqueId('__')
                                },
                                Data: [
                                    {
                                        Resource: [
                                            {
                                                $: {
                                                    resource: dialogGetAsset.selected
                                                }
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    };
                    break;
                }
                case "SCENE_SELECTED": {
                    pager = {
                        $: {
                            page: dialogGetAsset.sourceData.Player.$.label,
                            type: "scene"
                        },
                        Player: [
                            {
                                $: {
                                    src: dialogGetAsset.selected
                                }
                            }
                        ]
                    };
                    break;
                }
            }
            if (len > MAX_PLAYLIST_TIME) {
                this.showToastOverLength();
                return;
            }
            pages.push(pager);
        }

        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'Page',
                value: pages,
                storePath: 'Data[0].Flicking[0]'
            }]
        });
        super.initApplyStoreToDynamic(true);
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "label",
                storePath: '$.label'
            },
            {
                type: "radiobutton",
                label: this.translocoService.translate('general.direction', {}, this.translocoService.getActiveLang()),
                name: "vertical",
                options: ["horizontal", "vertical"],
                value: "horizon",
                storePath: 'Data[0].Flicking[0].$.vertical'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "label",
                storePath: '$.label'
            },
            {
                type: "input",
                label: '',
                inputType: 'tablelist',
                tableColumns: this.tableColumns,
                ignoreMissingValue: true,
                cloneVals: true,
                multiSelect: false,
                rememberSelection: true,
                allowFilter: true,
                buttonBarClassName: 'playlistButtonBar',
                buttons: this.buttons,
                inputEditFormat: {page: 'text'},
                requiredFields: {page: true},
                allowTableOnDialog: true,
                inputEditRenamePath: [{path: '$.page', key: 'page'}],
                name: "Page",
                storePath: 'Data[0].Flicking[0].Page',
                expandableEditor: true,
                enablePagination: true,
                disableSubmit: true,
                callBackEvent: (v) => this.onTableListChangeCallBack(v),
                callBackFaIcon: (v) => this.onCallBackIcon(v)
                // callBackFaIcon: (v) => BlockPlaylistComponent.onCallBackFaIcon(v),
            }
        ];
        // this.uiConfigInit = this.appendGpu(this.uiConfigInit);
    }

    private showToastOverLength() {
        this.toastr.error(this.translocoService.translate('general.tooLong24', {}, this.translocoService.getActiveLang()));
    }
}


